import { render, staticRenderFns } from "./ContratoTurma.vue?vue&type=template&id=2f210690&"
import script from "./ContratoTurma.vue?vue&type=script&lang=js&"
export * from "./ContratoTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports